import { useState, useEffect, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthProvider';
import { PageTitle, useLayout } from "../../../_metronic/layout/core";
import { DefaultTitle } from "../../../_metronic/layout/components/header/page-title/DefaultTitle";
import Board from './board';
import clsx from 'clsx';
import Swal from 'sweetalert2';
import EmpresasService from '../../services/EmpresasService';
import { uniqueId } from 'lodash';
import Select from 'react-select';
import ModalMapaConciliacao from './modal-mapa';
import RelatoriosService from '../../services/RelatoriosService';
import { startConnection, joinGroup, connectionValid, closeConnection } from '../../services/EsteiraWebSocket';

/*Tradução */
import '../../../i18n/config';
import { useTranslation } from 'react-i18next';
import ModalArquivosIniciais from './modal-arquivos-iniciais';
import ModalHistoricoEsteira from './modal-historico-esteira';
import ModalArquivosOperacao from './modal-arquivos-operacao';
import ModalSolicitacoesAlteracao from './modal-solicitacoes';
import ModalArquivosRetorno from './modal-arquivos-retorno';
import ModalOpcoesEmpresa from './modal-opcoes-empresa';
import AssistenteIa from './AssistenteIa';

function AndamentoContas() {

  const history = useHistory();
  const [iniciouCarregamentoTela, setIniciouCarregamentoTela] = useState<boolean>(false);

  const [empresas, setEmpresas] = useState<any[]>([]);
  const [empresaSelecionada, setEmpresaSelecionada] = useState<number>(0);
  const [mostrarReferencial, setMostrarReferencial] = useState<boolean>(true);
  const [carregandoEmpresa, setCarregandoEmpresa] = useState<boolean>(false);
  const { t } = useTranslation();
  const [esteiras, setEsteiras] = useState<any[]>([]);
  const [esteiraSelecionada, setEsteiraSelecionada] = useState<number>(0);
  const [carregandoEsteiras, setCarregandoEsteiras] = useState<boolean>(false);

  const [showModalOpcoes, setShowModalOpcoes] = useState<boolean>(false);
  const [showModalHistorico, setShowModalHistorico] = useState<boolean>(false);
  const [showModalArquivos, setShowModalArquivos] = useState<boolean>(false);
  const [showModalSolicitacoes, setShowModalSolicitacoes] = useState<boolean>(false);
  const [showModalArquivosRetorno, setShowModalArquivosRetorno] = useState<boolean>(false);
  const [showModalOpcoesEmpresa, setShowModalOpcoesEmpresa] = useState<boolean>(false);

  const [transportandoSaldo, setTransportandoSaldo] = useState<boolean>(false);
  const [iniciadoTransporte, setIniciadoTransporte] = useState<boolean>(false);

  const [porcentagem, setPorcentagem] = useState<number>(0);
  const [carregandoPorcentagem, setCarregandoPorcentagem] = useState<boolean>(false);

  const { usuario } = useAuth();
  const { classes } = useLayout();

  // Rollout restrito (DEVN3-609): assistente de IA visível só para usuários internos (@ainumera.com).
  // A mesma regra é aplicada no backend (AssistenteIaController) — aqui é só para esconder o ícone.
  const assistenteIaHabilitado = !!usuario?.email?.trim().toLowerCase().endsWith('@ainumera.com');

  const onChangeEsteira = useCallback((e: any, dados: any[] | null) => {
    const code = parseInt(e.target.value);
    const esteira = dados ? dados.find(f => f.id === code) : esteiras.find(f => f.id === code);
    if (esteira.porcentagem < 100) {
      setCarregandoPorcentagem(true);
    } else {
      setCarregandoPorcentagem(false);
    }

    setPorcentagem(esteira.porcentagem);
    setEsteiraSelecionada(code);
  }, [esteiras]);

  const onChangeEmpresa = useCallback((e: any) => {
    const code = parseInt(e.target.value);
    setEmpresaSelecionada(code);
    setEsteiras([]);
    setCarregandoEsteiras(true);
    setPorcentagem(0);
    EmpresasService.obterEsteiras(code).then((resp) => {
      setEsteiras(resp);
      setCarregandoEsteiras(false);
      const esteiraLocal = localStorage.getItem('andamento:esteira');
      if (esteiraLocal && resp.find(f => f.id === parseInt(esteiraLocal))) {
        onChangeEsteira({ target: { value: esteiraLocal } }, resp);
      }
    });
  }, []);

  const buscarEmpresas = useCallback(async () => {
    if (!carregandoEmpresa && usuario) {
      setCarregandoEmpresa(true);

      await RelatoriosService.obterEmpresasPorClienteID(0, (resp) => {
        setCarregandoEmpresa(false);
        setEmpresas(resp);
        const empresaLocal = localStorage.getItem('andamento:empresa');
        if (empresaLocal && resp.find(f => f.empresaID === parseInt(empresaLocal))) {
          onChangeEmpresa({ target: { value: empresaLocal } });
        }
      });
    }
  }, [carregandoEmpresa, usuario, onChangeEmpresa]);

  useEffect(() => {
    if (usuario && !iniciouCarregamentoTela) {
      setIniciouCarregamentoTela(true);
      buscarEmpresas();
    }
  }, [usuario, iniciouCarregamentoTela, buscarEmpresas]);

  useEffect(() => {
    if (usuario && esteiraSelecionada > 0) {
      const connect = async () => {
        try {
          await closeConnection();
          await startConnection();
          await joinGroup(`GROUP-${esteiraSelecionada}`);
          console.log('connected')
        } catch (e) {
          console.log('err to connect', e)
        }
      }

      connect();
    }
  }, [esteiraSelecionada, usuario]);


  useEffect(() => {
    if (esteiraSelecionada <= 0) {
      setTransportandoSaldo(false);
      return;
    }

    let ativo = true;

    const checarTransporte = async () => {
      try {
        const ops = await EmpresasService.buscarOperacoesEsteira(esteiraSelecionada);
        if (ativo) {
          setTransportandoSaldo(ops.some((o: any) => o.tipo === 'TRANSPORTAR_SALDO' && o.processando));
        }
      } catch {}
    };

    checarTransporte();
    const interval = setInterval(checarTransporte, 15000);

    return () => {
      ativo = false;
      clearInterval(interval);
    };
  }, [esteiraSelecionada, iniciadoTransporte]);

  const handleTransportarSaldo = async () => {
    try {
      await EmpresasService.transportarSaldo(esteiraSelecionada);
      setTransportandoSaldo(true);
      setIniciadoTransporte(prev => !prev);
    } catch (e: any) {
      const status = e?.response?.status;
      const msg = status === 409
        ? 'Não foi possível iniciar o transporte de saldo: esta esteira já possui saldo inicial transportado ou já existe uma operação de transporte em andamento. Desfaça o saldo inicial (ou aguarde a operação atual terminar) antes de tentar novamente.'
        : status === 422
          ? (e?.response?.data?.message ?? 'Não foi possível transportar o saldo. Existem contas que ainda não estão na coluna "Concluído". Finalize as conciliações pendentes e tente novamente.')
          : (e?.message ?? 'Erro ao iniciar transporte de saldo.');
      Swal.fire({
        text: msg,
        timer: 10000,
        icon: 'warning',
        showConfirmButton: true,
        confirmButtonText: 'OK'
      });
    }
  };

  const confirmarTransportarSaldo = () => {
    Swal.fire({
      title: t('Confirmar transporte de saldo?'),
      text: t('Esta ação transportará o saldo final das contas para o período seguinte. Para que o processo seja realizado corretamente, as contas devem estar na coluna "Concluído", com 100% da conciliação finalizada. Deseja continuar?'),
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: t('Sim'),
      cancelButtonText: t('Não'),
      confirmButtonColor: 'green',
      cancelButtonColor: 'red',
    }).then((result) => {
      if (result.isConfirmed) {
        handleTransportarSaldo();
      }
    });
  };

  const esteiraAtual = esteiras.find(f => f.id === esteiraSelecionada);
  const processamentoBloqueio = esteiraAtual?.processamentoBloqueio ?? false;
  const boardVisivel = esteiraSelecionada > 0 && empresaSelecionada > 0 && !carregandoPorcentagem && esteiraAtual && !processamentoBloqueio && !transportandoSaldo;
  const acoesVisiveis = empresaSelecionada > 0 && esteiraSelecionada > 0 && porcentagem >= 100;

  const anoEsteiraAtual = esteiraAtual ? new Date(esteiraAtual.periodoInicio).getFullYear() : null;
  const temEsteiraAnoPrevio = anoEsteiraAtual != null &&
    esteiras.some((e: any) => new Date(e.periodoInicio).getFullYear() === anoEsteiraAtual - 1);

  return (
    <>
      <PageTitle breadcrumbs={[]}>{t("Mapa de Conciliação")}</PageTitle>
      <div className='toolbar' id='kt_toolbar'>
        <div id='kt_toolbar_container' className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}>
          <DefaultTitle />
        </div>
      </div>

      {/* Filtros e ações */}
      <div className='card card-flush mb-4'>
        <div className='card-body py-4'>
          <div className='d-flex flex-wrap align-items-end gap-4'>

            {/* Empresa */}
            <div className='d-flex flex-column' style={{ minWidth: 260, flex: '1 1 260px' }}>
              <label className='form-label fw-semibold text-gray-700 mb-1'>
                <i className='fas fa-building me-1 text-primary'></i>
                {t('Empresa')}
              </label>
              {carregandoEmpresa ? (
                <div className='form-control d-flex align-items-center gap-2 text-muted'>
                  <span className='spinner-border spinner-border-sm'></span>
                  {t('Carregando...')}
                </div>
              ) : (
                <Select
                  placeholder={t('Selecione uma Empresa')}
                  isDisabled={carregandoEmpresa}
                  isClearable
                  value={empresaSelecionada > 0
                    ? empresas
                        .filter(item => item.empresaID === empresaSelecionada)
                        .map(item => ({
                          label: `${item.razaoSocial}${item.cnpj && item.cnpj.replace(/[^A-Za-z0-9]/g, '').substring(8, 12) !== '0001' ? ` - ${item.cnpj}` : ''}`,
                          value: item.empresaID,
                        }))[0] ?? null
                    : null
                  }
                  options={empresas.map(item => ({
                    label: `${item.razaoSocial}${item.cnpj && item.cnpj.replace(/[^A-Za-z0-9]/g, '').substring(8, 12) !== '0001' ? ` - ${item.cnpj}` : ''}`,
                    value: item.empresaID,
                  }))}
                  onChange={(option) => {
                    const val = option ? String(option.value) : '0';
                    localStorage.setItem('andamento:empresa', val);
                    onChangeEmpresa({ target: { value: val } });
                  }}
                  noOptionsMessage={() => t('Nenhuma empresa encontrada')}
                />
              )}
            </div>

            {/* Período */}
            <div className='d-flex flex-column' style={{ minWidth: 200, flex: '1 1 200px' }}>
              <label className='form-label fw-semibold text-gray-700 mb-1'>
                <i className='fas fa-calendar-alt me-1 text-primary'></i>
                {t('Período')}
              </label>
              {carregandoEsteiras ? (
                <div className='form-control d-flex align-items-center gap-2 text-muted'>
                  <span className='spinner-border spinner-border-sm'></span>
                  {t('Carregando...')}
                </div>
              ) : (
                <select
                  className='form-select'
                  disabled={carregandoEsteiras || empresaSelecionada === 0}
                  value={esteiraSelecionada}
                  onChange={(e) => {
                    localStorage.setItem('andamento:esteira', e.target.value);
                    onChangeEsteira(e, null);
                  }}
                >
                  <option value={0}>{t('Selecione um período')}</option>
                  {esteiras.map((item) => (
                    <option key={uniqueId()} value={item.id}>
                      {item.periodoInicioString} - {item.periodoFimString}
                    </option>
                  ))}
                </select>
              )}
            </div>

            {/* Ações — período normal */}
            {acoesVisiveis && !processamentoBloqueio && (
              <div className='d-flex align-items-end gap-2 flex-wrap'>
                <button
                  className='btn btn-sm btn-light-success d-flex align-items-center gap-1'
                  onClick={(e) => { e.stopPropagation(); setShowModalOpcoes(true); }}
                  title={t('Exportar relatório')}
                >
                  <i className='fas fa-file-export fs-6'></i>
                  {t('Exportar')}
                </button>
                <button
                  className='btn btn-sm btn-light-success d-flex align-items-center gap-1'
                  onClick={(e) => {
                    e.stopPropagation();
                    history.push(`/consulta-lancamentos?empresaId=${empresaSelecionada}&esteiraId=${esteiraSelecionada}`);
                  }}
                  title={t('Consultar lançamentos em grade (estilo Excel) e exportar o filtro')}
                >
                  <i className='fas fa-table fs-6'></i>
                  {t('Consultar Lançamentos')}
                </button>
                <button
                  className='btn btn-sm btn-light-primary d-flex align-items-center gap-1'
                  onClick={(e) => { e.stopPropagation(); setShowModalArquivos(true); }}
                  title={t('Arquivos da operação')}
                >
                  <i className='fas fa-folder-open fs-6'></i>
                  {t('Arquivos')}
                </button>
                <button
                  className='btn btn-sm btn-light-info d-flex align-items-center gap-1'
                  onClick={(e) => { e.stopPropagation(); setShowModalHistorico(true); }}
                  title={t('Histórico de operações')}
                >
                  <i className='fas fa-history fs-6'></i>
                  {t('Histórico')}
                </button>
                <button
                  className='btn btn-sm btn-light-warning d-flex align-items-center gap-1'
                  onClick={(e) => { e.stopPropagation(); setShowModalSolicitacoes(true); }}
                  title={t('Solicitações de alteração')}
                >
                  <i className='fas fa-clipboard-list fs-6'></i>
                  {t('Solicitações')}
                </button>
                <button
                  className='btn btn-sm btn-light-danger d-flex align-items-center gap-1'
                  onClick={(e) => { e.stopPropagation(); setShowModalArquivosRetorno(true); }}
                  title={t('Arquivos de retorno PDF')}
                >
                  <i className='fas fa-file-pdf fs-6'></i>
                  {t('Downloads')}
                </button>
                <button
                  className='btn btn-sm btn-light-dark d-flex align-items-center gap-1'
                  onClick={(e) => { e.stopPropagation(); confirmarTransportarSaldo(); }}
                  disabled={!temEsteiraAnoPrevio || transportandoSaldo}
                  title={!temEsteiraAnoPrevio ? t('Não há esteira ativa no ano anterior') : t('Transportar lançamentos do ano anterior')}
                >
                  {transportandoSaldo
                    ? <><span className='spinner-border spinner-border-sm me-1'></span>{t('transportar_saldo')}</>
                    : <><i className='fas fa-exchange-alt fs-6'></i>{t('Transportar Saldo')}</>
                  }
                </button>
                <button
                  className='btn btn-sm btn-light-dark d-flex align-items-center gap-1'
                  onClick={(e) => {
                    e.stopPropagation();
                    history.push(`/gerenciar-saldo-inicial?empresaId=${empresaSelecionada}&esteiraId=${esteiraSelecionada}`);
                  }}
                  title={t('Consultar e desfazer lançamentos de saldo inicial')}
                >
                  <i className='fas fa-undo fs-6'></i>
                  {t('Gerenciar Saldo Inicial')}
                </button>
                <button
                  className='btn btn-sm btn-light-secondary d-flex align-items-center gap-1'
                  onClick={(e) => { e.stopPropagation(); setShowModalOpcoesEmpresa(true); }}
                  title={t('Configurações da empresa (valem para todas as esteiras)')}
                >
                  <i className='fas fa-cog fs-6'></i>
                  {t('Opções')}
                </button>
              </div>
            )}

            {/* Ações — bloqueio de processamento */}
            {acoesVisiveis && processamentoBloqueio && (
              <div className='d-flex align-items-end'>
                <button
                  className='btn btn-sm btn-light-primary d-flex align-items-center gap-1'
                  onClick={(e) => { e.stopPropagation(); setShowModalOpcoes(true); }}
                >
                  <i className='fas fa-file-upload fs-6'></i>
                  {t('Arquivos Iniciais')}
                </button>
              </div>
            )}

          </div>
        </div>
      </div>

      {/* Modais */}
      <ModalMapaConciliacao onSetMostrarReferencial={setMostrarReferencial} empresaID={empresaSelecionada} esteiraID={esteiraSelecionada} show={showModalOpcoes && !processamentoBloqueio} toggleModal={() => setShowModalOpcoes(false)} />
      <ModalArquivosIniciais empresaID={empresaSelecionada} esteiraID={esteiraSelecionada} show={showModalOpcoes && processamentoBloqueio} toggleModal={() => setShowModalOpcoes(false)} />
      <ModalArquivosOperacao esteiraID={esteiraSelecionada} show={showModalArquivos} toggleModal={() => setShowModalArquivos(false)} />
      <ModalHistoricoEsteira esteiraID={esteiraSelecionada} show={showModalHistorico} toggleModal={() => setShowModalHistorico(false)} />
      <ModalSolicitacoesAlteracao esteiraID={esteiraSelecionada} show={showModalSolicitacoes} toggleModal={() => setShowModalSolicitacoes(false)} usuario={usuario ?? undefined} />
      <ModalArquivosRetorno esteiraID={esteiraSelecionada} empresaID={empresaSelecionada} esteira={esteiraAtual} show={showModalArquivosRetorno} toggleModal={() => setShowModalArquivosRetorno(false)} />
      <ModalOpcoesEmpresa empresaID={empresaSelecionada} show={showModalOpcoesEmpresa} toggleModal={() => setShowModalOpcoesEmpresa(false)} />

      {/* Conteúdo principal */}
      {boardVisivel && (
        <div className='mt-2'>
          <Board key={esteiraSelecionada} connection={connectionValid} mostrarReferencial={mostrarReferencial} empresaID={empresaSelecionada} esteira={esteiraAtual} />
        </div>
      )}

      {boardVisivel && assistenteIaHabilitado && <AssistenteIa esteiraId={esteiraSelecionada} />}

      {transportandoSaldo && !carregandoPorcentagem && (
        <div className='card card-flush'>
          <div className='card-body py-10 text-center'>
            <span className='spinner-border text-dark mb-4 d-block mx-auto' style={{ width: 40, height: 40 }}></span>
            <h5 className='fw-bold'>{t('transportar_saldo')}</h5>
            <p className='text-muted mb-0'>{t('Os lançamentos do ano anterior estão sendo transportados. Os cartões estarão disponíveis assim que o processo for concluído.')}</p>
          </div>
        </div>
      )}

      {processamentoBloqueio && !carregandoPorcentagem && (
        <div className='card card-flush'>
          <div className='card-body py-10 text-center'>
            <i className='fas fa-file-import fs-2x text-primary mb-4 d-block'></i>
            <h5 className='fw-bold'>{t('Importação de arquivos iniciais')}</h5>
            <p className='text-muted mb-0'>{t('É necessário completar a etapa de importação de arquivos para continuar o processamento das contas.')}</p>
          </div>
        </div>
      )}

      {carregandoPorcentagem && (
        <div className='card card-flush'>
          <div className='card-body py-10 text-center'>
            <div className='spinner-border text-primary mb-4' role='status'></div>
            <p className='text-muted mb-0'>{t('O arquivo está sendo processado por nossos servidores...')}</p>
          </div>
        </div>
      )}
    </>
  )
}

export default AndamentoContas;